module.exports = __webpack_public_path__ + "img/pantalla-1-13.896e57f1.png";